import { Injectable } from '@angular/core';
import {Observable, of} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserPreferencesService {
  private KEY = 'user-preference';
  private prefsModel = new PrefsModel();

  constructor() {
    this.init();
  }

  getLastLocation() {
    return this.prefsModel.lastLocation;
  }

  getLastZoom() {
    return this.prefsModel.lastZoom;
  }

  setLastLocation(loc: {lat: number, lng: number}) {
    this.prefsModel.lastLocation = loc;
    this.save();
  }

  setLastZoom(zoom: number) {
    this.prefsModel.lastZoom = zoom;
    this.save();
  }

  isFirstRun() {
    return this.prefsModel.isFirstRun;
  }

  consumeFirstRun() {
    this.prefsModel.isFirstRun = false;
    this.save();
  }

  private save() {
    sessionStorage.setItem(this.KEY, JSON.stringify(this.prefsModel));
  }

  private init() {
    const prefs = JSON.parse(sessionStorage.getItem(this.KEY) || '{}');
    if ( Object.keys(prefs).length > 0 ) {
      this.prefsModel = prefs;
    }
  }
}

export class PrefsModel {
  lastLocation: LatLng = {lat: 40.7484, lng: -73.9857};
  isFirstRun = true;
  lastZoom = 5;
}
export interface LatLng {
  lat: number;
  lng: number;
}
